import dayjs from "dayjs";

// index 0 = lundi, coherent avec les cles de ParametresDemandeMessagesFixe
export const JOURS_SEMAINE = ['lundi','mardi','mercredi','jeudi','vendredi','samedi','dimanche'];

// dayjs().day() renvoie 0 pour dimanche et n'est pas affecte par weekStart.
// Le decalage +6 modulo 7 aligne dimanche sur l'index 6.
export function jourSemaineFr(date:Date|string):string{
    return JOURS_SEMAINE[(dayjs(date).day() + 6) % 7].toLowerCase();
}
